import client from '../httpClient';

const schedulesGetUnregistGuidancesApi = (pathParameter, params) => {
  return client.get(`/guidances/unregist/${pathParameter}`, { params });
};

export default schedulesGetUnregistGuidancesApi;
